import { formatDateIT } from "@/lib/api";
import StatusBadge from "./StatusBadge";

export default function Timeline({ events = [] }) {
  if (!events?.length) {
    return <div className="text-sm text-slate-500 italic">Nessun evento registrato.</div>;
  }
  const sorted = [...events].sort((a, b) => (a.at < b.at ? 1 : -1));
  return (
    <div className="pl-1" data-testid="timeline">
      {sorted.map((e) => (
        <div key={e.id} className="timeline-item">
          <div className="flex flex-wrap items-center gap-2 mb-1">
            <StatusBadge status={e.to_status} />
            <span className="text-xs text-slate-500">{formatDateIT(e.at)}</span>
            {e.user_name && <span className="text-xs text-slate-500">· {e.user_name}</span>}
          </div>
          {e.note && <div className="text-sm text-slate-700 whitespace-pre-wrap">{e.note}</div>}
          {e.customer_visible_note && (
            <div className="mt-1 text-xs bg-fuchsia-50 text-[#9d174d] px-2 py-1 rounded-md inline-block">
              Nota visibile al cliente: {e.customer_visible_note}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
